<!--
  ■■■■■アクティビティログ記録用関数■■■■■
  <activity_function ref="activityfunc" />

  addtestlog() {
      this.$refs.activityfunc.addlog(
        "ideapost",
        "alidid",
        "aprjid",
        "adataid",
        "テスト",
        firebase.firestore.Timestamp.now()
      );
    },
-->

<template>
  <div id="activity"></div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default {
  name: "activity_function",
  /*
  [
    "class", // idea,comments,proposals,amendments,
    "lidid", // LidのID
    "projectid", // プロジェクトのID
    "dataid", //データのID
    "text", //内容
    "date",
  ],
  */
  data() {
    return {
      db: firebase.firestore(),
      counterdoc: null,
    };
  },
  methods: {
    /*
      addlogのラッパー。基本的にこちらを呼び出してください。
    */
    ideapost(lidid, dataid, text) {
      this.addlog(
        "ideapost",
        lidid,
        "",
        dataid,
        text,
        firebase.firestore.Timestamp.now()
      );
    },
    like(lidid, dataid, text) {
      this.addlog(
        "like",
        lidid,
        "",
        dataid,
        text,
        firebase.firestore.Timestamp.now()
      );
    },
    comments(lidid, projectid, dataid, text) {
      this.addlog(
        "comments",
        lidid,
        projectid,
        dataid,
        text,
        firebase.firestore.Timestamp.now()
      );
    },
    proposals(lidid, projectid, dataid, text) {
      this.addlog(
        "proposals",
        lidid,
        projectid,
        dataid,
        text,
        firebase.firestore.Timestamp.now()
      );
    },
    amendments(lidid, projectid, dataid, text) {
      this.addlog(
        "amendments",
        lidid,
        projectid,
        dataid,
        text,
        firebase.firestore.Timestamp.now()
      );
    },
    /*
      addlog ログイン以外のアクティビティログの記録
    */
    addlog(
      logclass, // ideapost,comments,proposals,amendments,
      lidid, // LidのID
      projectid, // プロジェクトのID
      dataid, //データのID
      text, //内容
      date
    ) {
      // ログの記録
      let collection = this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .collection("activity");
      collection
        .add({
          logclass: logclass,
          lidid: lidid,
          projectid: projectid,
          dataid: dataid,
          text: text,
          date: date,
        })
        .then(function () {})
        .catch(function (error) {
          console.error("ログの記入でエラーが発生しました。",logclass, error);
        });

      //カウンター上げとメダル付与チェック
      this.medalcheck(logclass, date);
    },
    medalcheck(logclass, date) {
      //メダル付与チェック
      const counterdoc = this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .collection("counter")
        .doc("counter");
      counterdoc
        .get()
        .then((doc) => {
          if (doc.exists) {
            let counter = doc.data();
            if (logclass == "ideapost") {
              this.getMedal(logclass, counter.count_ideapost, date);
            } else if (logclass == "comments") {
              this.getMedal(logclass, counter.comments, date);
            } else if (logclass == "proposals") {
              this.getMedal(logclass, counter.proposals, date);
            } else if (logclass == "amendments") {
              this.getMedal(logclass, counter.amendments, date);
            } else if (logclass == "like") {
              this.getMedal(logclass, counter.like, date);
            }
          } else {
            // 初回
            this.getMedal(logclass, 0, date);
          }
          //カウンターを上げる
          this.upcounter(logclass);
        })
        .catch((error) => {
          console.error("メダル付与チェック・アクティビティカウンター動作でエラーが発生しました。", error);
        });
    },

    // メダルの記録
    getMedal(logclass, count, date) {
      // numcountの型を固定
      let numcount = 0;
      if (count != undefined) {
        numcount = count;
      }
      // メダルの辞書
      // logclass: {付与前のカウンター: 付与されるメダルの数}
      const data2medal = {
        ideapost: {
          0: 1,
          9: 2,
          99: 3,
        },
        comments: {
          0: 1,
          9: 2,
          99: 3,
        },
        proposals: {
          0: 1,
          9: 2,
          99: 3,
        },
        amendments: {
          0: 1,
          9: 2,
          99: 3,
        },
        like: {
          0: 1,
          9: 2,
          99: 3,
        },
      };

      //メダル獲得辞書内に条件が含まれている場合、メダルを獲得
      if (data2medal[logclass][numcount] != undefined) {
        //console.log("getMedal", logclass, count, numcount, data2medal[logclass][numcount]);
        // メダル獲得履歴への記入
        const medalcollection = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.uid)
          .collection("medal");
        medalcollection
          .add({
            logclass: logclass,
            medals: data2medal[logclass][numcount],
            date: date,
          })
          .then(function () {})
          .catch(function (error) {
            console.error("メダルの記入でエラーが発生しました。", error);
          });
        // メダル総数の更新
        const userdoc = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.uid);
        userdoc.update({
          medals: firebase.firestore.FieldValue.increment(
            data2medal[logclass][numcount]
          ),
        });
      }
    },
    upcounter(logclass) {
      // アクティビティカウンターの増加
      const counterdoc = this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .collection("counter")
        .doc("counter");
      counterdoc.set(
        {
          isActive: true,
          lastupdate: firebase.firestore.Timestamp.now()
        },
        { merge: true }
      );
      if (logclass == "ideapost") {
        counterdoc.update({
          count_ideapost: firebase.firestore.FieldValue.increment(1),
        });
      } else if (logclass == "comments") {
        counterdoc.update({
          comments: firebase.firestore.FieldValue.increment(1),
        });
      } else if (logclass == "proposals") {
        counterdoc.update({
          proposals: firebase.firestore.FieldValue.increment(1),
        });
      } else if (logclass == "amendments") {
        counterdoc.update({
          amendments: firebase.firestore.FieldValue.increment(1),
        });
      } else if (logclass == "like") {
        counterdoc.update({
          like: firebase.firestore.FieldValue.increment(1),
        });
      }
    },
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || "";
    },
  },
};
</script>
    